import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import LoanTape from './LoanTape'
import LoanTapes from './LoanTapes'
import CreateLoanTape from './CreateLoanTape'
import GenerateLoanTapes from './GenerateLoanTapes'

const LoanTapesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <LoanTapes />
      </Route>

      <Route path={`${path}/create`}>
        <CreateLoanTape />
      </Route>

      <Route path={`${path}/generate`}>
        <GenerateLoanTapes />
      </Route>

      <Route path={`${path}/:loanTapeId`}>
        <LoanTape />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default LoanTapesRoutes
